import { connect } from "react-redux";
import { Button } from "react-bootstrap";
import TrashBin from "../../../components/trash_bin/trash_bin";
import { useParams, useLocation } from 'react-router-dom';
import { useContext, useEffect } from "react";
import { ContentGroupPopupContext } from "../../../contexts/ContentGroupPopupContext";
import ContentList from '../ContentPage/list';

const RecycleBinPage = (props) => {
  const { organization_id, workspace_id, content_group_id } = useParams();
  const { contentGroupPopUp, setContentGroupPopUp } = useContext(ContentGroupPopupContext); 

  useEffect(() => {
    if(workspace_id && content_group_id){
      setContentGroupPopUp({ id: content_group_id, show:true, workspace_id });
    }
    return () => {
      
    };
  }, []);

  return (
    <>
      <div className="container page_layout">
        <h1 className="h2 mb-3">Recycle Bin</h1>
        <TrashBin organization_id={organization_id}/>
      </div>

       {
        contentGroupPopUp.show &&
          <ContentList
            content_group_id={contentGroupPopUp.id}
            contentGroupPopUp={contentGroupPopUp}
            setContentGroupPopUp={setContentGroupPopUp}
            workspace_id={contentGroupPopUp.workspace_id}
            handleCloseContentGroupPopUp={() => setContentGroupPopUp({ id: null, show:false, workspace_id: null })}
            handleInlineEdit={() => {}}
            fromRecycleBin
            readOnly
          />
        }
    </>

  );
};

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps, {})(RecycleBinPage);